import apios from './apios';

const axios = require('axios');

const apiosWithToken = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})

apiosWithToken.interceptors.request.use(function (config) {
    const token = localStorage.getItem('access')
    config.headers.Authorization = `Bearer ${token}`;
    return config;
});

apiosWithToken.interceptors.response.use(function (response) {
    return response
}, function (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        return apios.post('/auth/token/refresh/', {
            refresh: localStorage.getItem('refresh')
        }).then(res => {
            if (res.status === 200) {
                localStorage.setItem('access', res.data.access);
                axios.token.defaults.headers.common['Authorization'] = `Bearer ${res.data.access}`
                return axios(originalRequest)
            }
            else {
                localStorage.removeItem("refresh");
                localStorage.removeItem("access");
                location.reload();
            }
        }).catch((error) => {
            if (error.response.data.refresh == "Token is Invalid or Expired") {
                localStorage.removeItem("refresh");
                localStorage.removeItem("access");
                location.reload();
            }
        });
    }
    return Promise.reject(error)
})

export default apiosWithToken